// 桌面 Google 登录沿用 Google Identity Services：Google 自己弹小窗授权，直接把 access_token 回传给页面，页面不动。
// 这是线上一直在用的链路，其他平台没有同类 SDK，各走自己的小窗流程。

const GIS_SCRIPT_URL = 'https://accounts.google.com/gsi/client'
let scriptPromise = null

function loadGoogleIdentity() {
  if (globalThis.google?.accounts?.oauth2) return Promise.resolve()
  if (scriptPromise !== null) return scriptPromise
  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = GIS_SCRIPT_URL
    script.async = true
    script.onload = resolve
    script.onerror = () => reject(new Error('Google Identity Services failed to load'))
    document.head.append(script)
  })
  return scriptPromise
}

/**
 * 弹 Google 授权小窗，resolve 出 access_token；用户关掉小窗或授权失败时 reject。
 * @param {string} clientId
 * @returns {Promise<string>}
 */
export async function requestGoogleAccessToken(clientId) {
  await loadGoogleIdentity()
  return new Promise((resolve, reject) => {
    const client = globalThis.google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      scope: 'openid email profile',
      callback: response => {
        if (response.error || !response.access_token) {
          reject(new Error(response.error || 'Google access token missing'))
          return
        }
        resolve(response.access_token)
      },
      error_callback: error => reject(new Error(error?.type || 'Google popup failed')),
    })
    client.requestAccessToken()
  })
}
